import React from 'react'


export const Data = React.createContext(null);